<template>
	<card-toolbar style="padding-bottom: 30px;">
		<div slot="left" class="buttons has-addons">
			<div class="mr-10">スタッフ</div>
			<b-select class="" v-model="staffId">
				<option value="">未選択</option>
				<option
					v-for="(staff, index) in staffs"
					:value="staff.id"
					:key="index">
					{{ staff.name }}
				</option>
			</b-select>

			<div class="ml-30 mr-10">店舗</div>
			<b-select class="" v-model="shopId">
				<option value="">未選択</option>
				<option
					v-for="(shop, index) in shops"
					:value="shop.id"
					:key="index">
					{{ shop.name }}
				</option>
			</b-select>

			<div v-if="isDateShow" class="ml-30 mr-10">日程</div>
			<div class="date-picker">
				<date-picker v-if="isDateShow" :dateProvided="dateProvided" :minDate="minDate" :maxDate="maxDate" @input="onDateInput"></date-picker>
			</div>
		</div>

		<div slot="right" class="buttons has-addons">
			<b-button class="search-button" type="is-success" @click="onSearchButtonClick">検索</b-button>
		</div>
	</card-toolbar>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
import DatePicker from '@/components/DatePicker'
import moment from 'moment'

export default {
	name: "ScheduleTableToolbar",
	props: {
		isDateShow: {
			type: Boolean,
			default: false,
		},
		staffs: {
			type: Array,
			default: null,
		},
		shops: {
			type: Array,
			default: null,
		},
		year: {
			type: String,
			default: '',
		},
		month: {
			type: String,
			default: '',
		},
		dateProvided: {
			type: String,
			default: '',
		},
		minDate: {
			type: String,
			default: '',
		},
		maxDate: {
			type: String,
			default: '',
		},
	},
	components: {
		CardToolbar,
		DatePicker,
	},
	data() {
		return {
			staffId: '',
			shopId: '',
		}
	},
	computed: {
		/*
		minDate: function() {
			return moment(this.createFirstDay()).format('YYYY-MM-DD');
		},
		maxDate: function() {
			return moment(this.createFirstDay()).endOf('month').format('YYYY-MM-DD');
		},
		*/
	},
	methods: {
		//createFirstDay: function() {
		//	return `${this.year}-${this.$utils.zeroPadding(this.month, 2)}-01`;
		//},
		onSearchButtonClick: function() {
			this.$emit('search-button-click', this.staffId, this.shopId, this.dateProvided);
		},
		onDateInput: function(date) {
			this.$emit('input', date);
		},
	}
}
</script>

<style scoped>

</style>
